import type { ApplicationStateConfig } from './types';
import type { ApplicationState } from '../../types/tracked-job';

/**
 * Mutually exclusive application states configuration
 * Only one of these can be active at a time.
 * Icons are loaded from public/icons/ (cacheable SVGs).
 */
export const APPLICATION_STATES: ApplicationStateConfig[] = [
  { value: 'interviewing', labelKey: 'tools.applicationState.interviewing', defaultLabel: 'Interviewing', color: 'purple', icon: 'briefcase', iconSolid: 'briefcase' },
  { value: 'offer', labelKey: 'tools.applicationState.offer', defaultLabel: 'Offer', color: 'green', icon: 'arrowUpOnSquare', iconSolid: 'arrowUpOnSquare' },
  { value: 'rejected', labelKey: 'tools.applicationState.rejected', defaultLabel: 'Rejected', color: 'red', icon: 'xCircle', iconSolid: 'xCircle' },
  { value: 'hired', labelKey: 'tools.applicationState.hired', defaultLabel: 'Hired', color: 'emerald', icon: 'checkCircle', iconSolid: 'checkCircle' },
];
